import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import $ from "jquery";

const Ads = () => {

    const [data, setData] = useState([]);
    const [inId, setIntId] = useState([]);
    const getData = async () => {
        const { data } = await axios.get('/auth/ads');
        setData(data);
        setIntId(data.id)
    };

    const [selectedFile, setSelectedFile] = useState(null);
    const uploadChange = async (e) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        const { data } = await axios.post("/upload", formData);
        setSelectedFile(data);
    };

    useEffect(() => {
        getData();
        $('.nav-item').removeClass('active');
        $('.nav-item').each(function () {
            if ($(this).find('a').attr('href') === window.location.pathname) {
                $(this).addClass('active');
            }
        });
    }, []);


    return (
        <div className="page-content">
            <nav className="page-breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/">دەستپێک</a></li>
                    <li className="breadcrumb-item active" aria-current="page">ڕاگەهاندن</li>
                </ol>
            </nav>
            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <h6 className="card-title">ڕاگەهاندن</h6>
                                </div>
                                <div className="col-md-12">
                                    <form onSubmit={(e) => {
                                        e.preventDefault();
                                        const formData = new FormData(e.target);
                                        const data = Object.fromEntries(formData);
                                        axios.put(`/auth/ads/${inId}`, data).then(() => {
                                            toast.success('هاتە گهوڕین');
                                            setTimeout(() => {
                                                window.location.reload(true)
                                            }, 1000);
                                        })
                                    }} >
                                        <div className="row">
                                            <div className="col-md-7">
                                                <div className="mb-3">
                                                    <label className="form-label">ناڤەڕۆک</label>
                                                    <textarea type="text" className="form-control" name="content" col={8} defaultValue={data.content} placeholder="ناڤەڕۆکا ڕاگەهاندنێ ..." required />
                                                </div>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="mb-3">
                                                    <label className="form-label">پۆستەر</label>
                                                    <input type="file" className="form-control" onChange={uploadChange} accept="application/pdf, image/*" />
                                                    <input type="hidden" name="image" defaultValue={selectedFile ? selectedFile : data.image} />
                                                    <small className="text-muted">{data.image}</small>
                                                </div>
                                            </div>
                                            <div className="col-md-7">
                                                <div className="mb-3">
                                                    <label className="form-label">لینک</label>
                                                    <input type="text" className="form-control" name="linkto" defaultValue={data.linkto} placeholder="لینکێ ڕاگەهاندنێ ...." required />
                                                </div>
                                            </div>
                                        </div>
                                        <button type="submit" className="btn btn-primary">گهوڕین</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
}

export default Ads;